import { addNullable } from 'components/forms/BurnBedsGrid/burnBedsUtils';

export type RehabBedsFormFields = {
  rehabLicensedInpatientAdultBeds: number | null;
  rehabLicensedInpatientPediatricBeds: number | null;
  rehabLicensedInpatientTotalBeds: number | null;
};

export const computeRehabBedTotal = (
  values: Partial<RehabBedsFormFields>,
): Pick<RehabBedsFormFields, 'rehabLicensedInpatientTotalBeds'> => ({
  rehabLicensedInpatientTotalBeds: addNullable(
    values.rehabLicensedInpatientAdultBeds,
    values.rehabLicensedInpatientPediatricBeds,
  ),
});
